<template>
  <div>
    <el-card>
      <page-table :code="params.code" :disabled="isDisableEditForm"/>
    </el-card>
  </div>
</template>
<script>
import PageTable from "../components/detail-page"
export default {
  name: "plan-planMaterial-detail",
  components: { PageTable },
  computed:{
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    isDisableEditForm() {
      return this.pageType === 'detail'
    }
  }
}
</script>
